export default __webpack_public_path__ + "static/media/eye-gray.d809f05a.svg";